// Service page data (NL/EN). Each entry powers a SEO-rich service page.

export const services = {
  "mobiele-truckwash": {
    slug: "mobiele-truckwash",
    nav_key: "mobile_truckwash",
    image: "/images/project19.jpg",
    keywords: "mobiele truckwash, mobiele wasstraat, vrachtwagen wassen op locatie, truckwash op locatie",
    nl: {
      title: "Mobiele Truckwash op locatie",
      meta_title: "Mobiele Truckwash op Locatie | Wasz.nl",
      meta_desc: "Mobiele truckwash voor uw vrachtwagens en trailers op uw eigen locatie. Snel, professioneel, biologisch afbreekbaar — met digitale registratie in WaszBase.",
      h1: "Mobiele Truckwash op locatie",
      lead: "Onze mobiele wasstraat komt naar uw vestiging, distributiecentrum of standplaats. Geen rij-uren, geen wachttijd, geen verloren productiviteit.",
      sections: [
        { title: "Wat is mobiele truckwash?", body: "Mobiele truckwash betekent dat wij vrachtwagens, trailers en bedrijfsvoertuigen op locatie reinigen met volledig uitgeruste service-units. Hierdoor hoeft uw wagenpark niet stil te staan of naar een vaste wasstraat te rijden. We werken efficiënt, professioneel en conform alle Nederlandse milieuregels." },
        { title: "Wanneer u kiest voor mobiele reiniging", body: "Vooral relevant voor transportbedrijven, distributiecentra, foodservice-vloten en bouwondernemingen die voertuigen niet kunnen of willen verplaatsen voor een wasbeurt. Onze mobiele wasstraat past in uw rijschema en wast tijdens stilstandsmomenten." },
        { title: "Standaard wasprotocol", body: "Voorspoelen, schuimreiniging, velgen reinigen, hogedruk afspoelen, ramen en spiegels nawassen, en eindcontrole. Optioneel: chassis ontvetten. Voor levensmiddelentransport voegen wij een HACCP-conforme stap toe inclusief certificaat." },
      ],
      bullets: [
        "Vrachtwagens, trekkers, trailers en opleggers",
        "Reiniging exterieur, chassis en (op verzoek) interieur",
        "Biologisch afbreekbare middelen, gecontroleerde waterafvoer",
        "Per-kenteken registratie in WaszBase",
        "HACCP-certificaten beschikbaar voor levensmiddelentransport",
        "Landelijke dekking vanuit Almere & Den Haag",
      ],
    },
    en: {
      title: "Mobile Truckwash at your location",
      meta_title: "Mobile Truckwash at your Location | Wasz.nl",
      meta_desc: "Mobile truckwash for your trucks and trailers at your own site. Fast, professional, biodegradable — with digital registration in WaszBase.",
      h1: "Mobile Truckwash at your location",
      lead: "Our mobile wash unit comes to your depot, distribution center or yard. No driving hours, no queuing, no lost productivity.",
      sections: [
        { title: "What is mobile truckwash?", body: "Mobile truckwash means we clean trucks, trailers and commercial vehicles on-site using fully equipped service units. This way your fleet doesn't have to stand idle or drive to a fixed wash bay. We work efficiently, professionally and in line with all Dutch environmental regulations." },
        { title: "When mobile cleaning makes sense", body: "Especially relevant for transport companies, DCs, foodservice fleets and construction operators that cannot or do not want to move vehicles for a wash. Our mobile wash slots into your driving schedule and cleans during downtime." },
        { title: "Standard wash protocol", body: "Pre-rinse, foam clean, rim cleaning, high-pressure rinse, glass and mirror finish, and final inspection. Optional: chassis degrease. For food transport we add a HACCP-compliant step including certificate." },
      ],
      bullets: [
        "Trucks, tractors, trailers and semi-trailers",
        "Exterior, chassis and (on request) interior",
        "Biodegradable agents, controlled water disposal",
        "Per-license-plate registration in WaszBase",
        "HACCP certificates available for food transport",
        "Nationwide coverage from Almere & The Hague",
      ],
    },
  },
  "vrachtwagenreiniging": {
    slug: "vrachtwagenreiniging",
    nav_key: "truck_cleaning",
    image: "/images/project20.jpg",
    keywords: "vrachtwagenreiniging, truck cleaning Nederland, vrachtwagen wassen, HACCP vrachtwagenreiniging",
    nl: {
      title: "Vrachtwagenreiniging — exterieur, interieur & HACCP",
      meta_title: "Vrachtwagenreiniging | HACCP-conform | Wasz.nl",
      meta_desc: "Professionele vrachtwagenreiniging voor exterieur, interieur en HACCP-conforme reiniging voor levensmiddelentransport. NVWA-klaar dossier in WaszBase.",
      h1: "Vrachtwagenreiniging op specialistisch niveau",
      lead: "Van standaard exterieurwas tot HACCP-conforme reiniging voor levensmiddelentransport: wij voeren de volledige scope vrachtwagenreiniging uit, met certificaat en kentekenregistratie.",
      sections: [
        {
          title: "Vier reinigingsniveau's",
          body: "Eén heldere prijslijst, vier oplopende niveaus. Per voertuig kiest u het pakket dat bij de lading past — wij voeren het exact zo uit op locatie.",
          levels: [
            { tier: "Niveau 1", name: "Standaard exterieurwas", body: "Cabine, opbouw en velgen worden gereinigd voor een professionele uitstraling op de weg." },
            { tier: "Niveau 2", name: "Exterieur + chassis", body: "Alles van niveau 1, aangevuld met volledige chassisreiniging voor zware vervuiling en inspectie-klare uitstraling." },
            { tier: "Niveau 3", name: "Inclusief binnenkant vloer", body: "Alles van niveau 2, aangevuld met de binnenkant vloer voor laadruimte zonder restvuil tussen ladingen." },
            { tier: "Niveau 4", name: "HACCP-conform compleet", body: "Alles van niveau 3, aangevuld met HACCP-conforme inwendige reiniging voor levensmiddelentransport — digitaal certificaat per kenteken." },
          ],
        },
        { title: "HACCP & levensmiddelentransport", body: "Bij elke HACCP-wasbeurt levert u een digitaal certificaat met datum, kenteken, gebruikt middel en operator — direct beschikbaar in uw WaszBase-dossier en klaar voor NVWA-controles." },
        { title: "Geschikt voor", body: "Koeltransport, foodlogistiek, bouwlogistiek, retaildistributie en algemene transportondernemingen." },
      ],
      bullets: [
        "Exterieur, chassis, interieur cabine, opbouw",
        "HACCP-conforme inwendige reiniging laadruimte",
        "Certificaat per wasbeurt en kenteken",
        "Digitaal NVWA-dossier in WaszBase",
        "Landelijk inzetbaar",
        "Vaste contractprijzen mogelijk",
      ],
    },
    en: {
      title: "Truck cleaning — exterior, interior & HACCP",
      meta_title: "Truck Cleaning | HACCP-compliant | Wasz.nl",
      meta_desc: "Professional truck cleaning for exterior, interior and HACCP-compliant cleaning for food transport. NVWA-ready dossier in WaszBase.",
      h1: "Specialist-grade truck cleaning",
      lead: "From standard exterior wash to HACCP-compliant cleaning for food transport: we cover the full truck cleaning scope, with certificate and license-plate registration.",
      sections: [
        {
          title: "Four cleaning levels",
          body: "One clear price list, four progressive levels. Per vehicle you pick the package that fits the cargo — we deliver it exactly that way on-site.",
          levels: [
            { tier: "Level 1", name: "Standard exterior wash", body: "Cab, body and rims are cleaned for a professional on-the-road presentation." },
            { tier: "Level 2", name: "Exterior + chassis", body: "Everything from level 1, plus full chassis cleaning for heavy soiling and inspection-ready presentation." },
            { tier: "Level 3", name: "Including cargo floor", body: "Everything from level 2, plus the interior cargo floor for residue-free loading between cargoes." },
            { tier: "Level 4", name: "HACCP-compliant complete", body: "Everything from level 3, plus HACCP-compliant interior cleaning for food transport — digital certificate per license plate." },
          ],
        },
        { title: "HACCP & food transport", body: "For every HACCP wash you receive a digital certificate with date, license plate, agent used and operator — instantly available in your WaszBase dossier and ready for NVWA inspections." },
        { title: "Suitable for", body: "Refrigerated transport, food logistics, construction logistics, retail distribution and general transport operators." },
      ],
      bullets: [
        "Exterior, chassis, cab interior, body",
        "HACCP-compliant interior cargo-space cleaning",
        "Certificate per wash and license plate",
        "Digital NVWA dossier in WaszBase",
        "Nationwide deployment",
        "Fixed contract pricing available",
      ],
    },
  },
  "fleet-cleaning": {
    slug: "fleet-cleaning",
    nav_key: "fleet_cleaning",
    image: "/images/project17.jpg",
    keywords: "fleet cleaning, fleet wash, mobiele cleaning service, vrachtwagenvloot wassen",
    nl: {
      title: "Fleet Cleaning — structurele reiniging voor uw hele vloot",
      meta_title: "Fleet Cleaning Nederland | Structureel Wagenpark Wassen | Wasz.nl",
      meta_desc: "Fleet Cleaning op contract: vaste cyclus, vaste prijs, volledige rapportage per kenteken via WaszBase. Voor vloten van 10 tot 1000+ voertuigen.",
      h1: "Fleet Cleaning voor transport-Nederland",
      lead: "Een vloot blijft niet vanzelf representatief. Met onze Fleet Cleaning-contracten houden wij uw wagenpark structureel schoon — voorspelbaar, controleerbaar en factuur-transparant.",
      sections: [
        { title: "Hoe een Fleet Cleaning-contract werkt", body: "We brengen uw vloot in kaart per locatie en kenteken. Op basis daarvan stellen we een wascyclus vast (wekelijks, tweewekelijks of maandelijks) met vaste prijs per voertuig. Onze teams plannen de wasbeurten in uw beschikbare slots in." },
        { title: "Volledig digitaal dossier", body: "Elke wasbeurt wordt direct in WaszBase vastgelegd: kenteken, locatie, type wasbeurt, operator, datum en certificaat. Maandelijkse rapportages en facturen zijn één klik weg." },
        { title: "Schaalbaar van 10 tot 1000+", body: "Onze infrastructuur is gebouwd op grote vloten. We werken met meerdere mobiele teams parallel en kunnen uw maandelijkse wasvolume binnen 4 weken opschalen." },
      ],
      bullets: [
        "Vaste cyclus & vaste prijzen",
        "SLA-gebaseerde plannings­garantie",
        "Per-kenteken historie en rapportage",
        "Onderverdeling per sub-klant en kostenplaats",
        "Maandelijkse vlootreview met prestatie-dashboard",
      ],
    },
    en: {
      title: "Fleet Cleaning — structural cleaning for your entire fleet",
      meta_title: "Fleet Cleaning Netherlands | Structural Fleet Washing | Wasz.nl",
      meta_desc: "Contract-based fleet cleaning: fixed cycle, fixed pricing, full reporting per license plate via WaszBase. For fleets from 10 to 1000+ vehicles.",
      h1: "Fleet Cleaning for transport Netherlands",
      lead: "A fleet doesn't stay representative on its own. With our fleet cleaning contracts we keep your fleet structurally clean — predictable, controllable and invoice-transparent.",
      sections: [
        { title: "How a fleet contract works", body: "We map your fleet by location and license plate. Based on that we set a wash cycle (weekly, biweekly or monthly) with fixed pricing per vehicle. Our teams schedule washes within your available slots." },
        { title: "Fully digital dossier", body: "Every wash is recorded immediately in WaszBase: license plate, location, wash type, operator, date and certificate. Monthly reports and invoices are one click away." },
        { title: "Scalable from 10 to 1000+", body: "Our infrastructure is built for large fleets. We deploy multiple mobile teams in parallel and can scale your monthly wash volume within 4 weeks." },
      ],
      bullets: [
        "Fixed cycles & fixed pricing",
        "SLA-based planning guarantee",
        "Per-license-plate history and reporting",
        "Sub-customer and cost-center billing",
        "Monthly fleet review with KPI dashboard",
      ],
    },
  },
  "wagenpark-reiniging": {
    slug: "wagenpark-reiniging",
    nav_key: "wagenpark",
    image: "/images/project7.jpg",
    keywords: "wagenpark reiniging, wagenpark wassen, mobiele reiniging transportbedrijven",
    nl: {
      title: "Wagenpark Reiniging — efficiëntie & uitstraling samen",
      meta_title: "Wagenpark Reiniging Nederland | Mobiel & Structureel | Wasz.nl",
      meta_desc: "Professionele wagenpark reiniging voor transport, distributie en bedrijfsvloten. Mobiel op locatie, met digitaal certificaat- en factuurbeheer.",
      h1: "Wagenpark reiniging voor zakelijk Nederland",
      lead: "Of u nu 8 bestelbussen runt of 800 vrachtwagens — uw wagenpark verdient consistente, professionele reiniging die past in uw operationele ritme.",
      sections: [
        { title: "Eén partij voor alle voertuigtypes", body: "Vrachtwagens, trailers, opleggers, bestelbussen, koelvoertuigen, kraanwagens en bedrijfsauto's. Eén contract, één facturatiestroom, één dossier per kenteken." },
        { title: "Premium uitstraling = premium klantbeleving", body: "Uw wagenpark is uw rijdende visitekaart. Onze structurele reiniging zorgt dat uw merk er elke dag scherp uitziet, op iedere snelweg en bij iedere klant." },
        { title: "Operationele integratie", body: "We koppelen onze planning aan uw operationele systeem. Wasbeurten worden gepland tijdens stilstand of tankstops, zonder verstoring van uw distributieschema — of u nu vanuit [Almere](/truckwash-almere) rijdt, vanuit [Amsterdam](/truckwash-amsterdam) of vanuit [Utrecht](/truckwash-utrecht) distribueert." },
      ],
      bullets: [
        "Alle voertuigtypes onder één contract",
        "Centrale facturering met sub-klant splitsing",
        "Digitale dossiers per kenteken",
        "Maandelijkse review meetings",
        "Schaalbaar zonder herbeoordeling",
      ],
    },
    en: {
      title: "Fleet Maintenance Cleaning — efficiency meets brand",
      meta_title: "Fleet Maintenance Cleaning Netherlands | Wasz.nl",
      meta_desc: "Professional fleet cleaning for transport, distribution and corporate fleets. Mobile on-site, with digital certificate and invoice management.",
      h1: "Fleet maintenance cleaning for business Netherlands",
      lead: "Whether you run 8 vans or 800 trucks — your fleet deserves consistent, professional cleaning that fits your operational rhythm.",
      sections: [
        { title: "One partner for every vehicle type", body: "Trucks, trailers, semi-trailers, vans, refrigerated vehicles, crane trucks and company cars. One contract, one billing stream, one dossier per license plate." },
        { title: "Premium look = premium customer experience", body: "Your fleet is your moving brand. Our structural cleaning keeps your identity sharp every day, on every highway and at every customer." },
        { title: "Operational integration", body: "We sync our planning with your operations. Washes happen during downtime or fuel stops, with no disruption to your distribution schedule." },
      ],
      bullets: [
        "All vehicle types under one contract",
        "Central billing with sub-customer splits",
        "Digital dossiers per license plate",
        "Monthly review meetings",
        "Scalable without re-tender",
      ],
    },
  },
  "haccp-certificaten": {
    slug: "haccp-certificaten",
    nav_key: "haccp",
    image: "/images/cleaning.png",
    keywords: "HACCP vrachtwagenreiniging, NVWA certificaten, HACCP certificaat truck",
    nl: {
      title: "HACCP & NVWA-documentatie — voor klanten met voedselveiligheids­eisen",
      meta_title: "HACCP Vrachtwagenreiniging | NVWA-documentatie | Wasz.nl",
      meta_desc: "Reiniging volgens HACCP-werkwijze, met digitale documentatie per kenteken in WaszBase. Geschikt voor transportbedrijven met voedselveiligheids- en NVWA-eisen.",
      h1: "HACCP & NVWA: voorbereid zonder paperwork",
      lead: "Voedseltransport vraagt om bewijslast. Wij leveren de reiniging volgens uw HACCP-eisen plus de bijbehorende documentatie — u levert alleen het kenteken.",
      sections: [
        { title: "Wat HACCP voor uw vloot betekent", body: "HACCP (Hazard Analysis and Critical Control Points) verplicht ú als opdrachtgever tot een gevalideerd reinigingsproces, traceerbaar per voertuig en per ladingstype. Onze werkwijze sluit hierop aan: we volgen een vaste reinigingsstandaard die past binnen uw HACCP-systeem en leveren per wasbeurt de onderbouwende registratie." },
        { title: "Documentatie per wasbeurt", body: "Elke reiniging die volgens HACCP-werkwijze wordt uitgevoerd levert een digitale registratie met operator, datum, gebruikt middel en kenteken. De registraties worden automatisch gekoppeld aan het juiste voertuig in WaszBase, klaar om binnen uw eigen HACCP-dossier op te nemen." },
        { title: "NVWA-controle in 30 seconden", body: "Bij een NVWA-controle exporteert u in WaszBase direct het complete dossier per kenteken: alle wasbeurten, gebruikte middelen en handtekeningen. Eén klik, één PDF, direct te tonen aan de controleur." },
      ],
      bullets: [
        "Reinigingsproces dat aansluit op HACCP-eisen",
        "Digitale registratie per wasbeurt en kenteken",
        "Per-voertuig dossiers in WaszBase",
        "PDF-export ter ondersteuning van uw HACCP-/NVWA-dossier",
        "Realtime beheer van reinigingsregistraties",
      ],
    },
    en: {
      title: "HACCP & NVWA documentation — for customers with food-safety requirements",
      meta_title: "HACCP Truck Cleaning | NVWA Documentation | Wasz.nl",
      meta_desc: "Cleaning aligned with HACCP working methods, with digital documentation per license plate in WaszBase. Suitable for transport companies with food-safety and NVWA requirements.",
      h1: "HACCP & NVWA: prepared without paperwork",
      lead: "Food transport demands evidence. We deliver the cleaning aligned with your HACCP requirements plus the supporting documentation — you just provide the license plate.",
      sections: [
        { title: "What HACCP means for your fleet", body: "HACCP (Hazard Analysis and Critical Control Points) obliges you as operator to maintain a validated cleaning process, traceable per vehicle and cargo type. Our working method is set up to support that: we follow a consistent cleaning standard that fits inside your HACCP system and deliver the underlying records per wash." },
        { title: "Documentation per wash", body: "Every cleaning performed to HACCP working methods produces a digital record with operator, date, agent used and license plate. Records are automatically linked to the right vehicle in WaszBase, ready to be included in your own HACCP dossier." },
        { title: "NVWA inspection in 30 seconds", body: "During an NVWA inspection you export the complete dossier per license plate from WaszBase: all washes, agents and signatures. One click, one PDF, ready to present to the inspector." },
      ],
      bullets: [
        "Cleaning process aligned with HACCP requirements",
        "Digital record per wash and license plate",
        "Per-vehicle dossiers in WaszBase",
        "PDF export to support your HACCP/NVWA file",
        "Real-time management of cleaning records",
      ],
    },
  },
};

export const serviceList = Object.values(services);
